import { SearchType } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.types';
import { TranslateRegistry } from 'src/app/services/translate/translate.registry';
import { SEARCH_HINTS } from 'src/app/shared/components/listing-page/services/listing-page-model/listing-page-model.constants';
import { DeviceListingFieldName, EquipmentListingFieldName } from '../../components/devices.models';

export const DCU_SEARCH_TYPES: SearchType[] = [
  {
    text: TranslateRegistry.get.SEARCH.TYPE.COMM_DEVICE_ID,
    value: 1,
    types: [DeviceListingFieldName.CommDeviceId],
    hintText: SEARCH_HINTS.CommDeviceId
  },
  {
    text: TranslateRegistry.get.SEARCH.TYPE.MODEL_NAME,
    value: 2,
    types: [DeviceListingFieldName.ModelName],
    hintText: SEARCH_HINTS.ModelName
  }
];

export const DCU_DEFAULT_SEARCH_TYPE: SearchType = DCU_SEARCH_TYPES[0];

export const DCU_SORT_FIELD: Record<string, EquipmentListingFieldName> = {
  deviceTypeName: DeviceListingFieldName.DeviceType,
  modelName: DeviceListingFieldName.ModelName,
  status: DeviceListingFieldName.Status,
  deviceStatusValue: DeviceListingFieldName.Health,
  lastHeard: DeviceListingFieldName.LastHeard,
  batteryStatus: DeviceListingFieldName.BatteryStatus
};
